const _bottom = "bottom"
const _center = "center"
const _left = "left"
const _right = "right"
const _top = "top"
const config = { "bottom": _bottom, "center": _center, "left": _left, "right": _right, "top": _top, "left-bottom": "left bottom", "left-top": "left top", "right-bottom": "right bottom", "right-top": "right top",  }
export { config as default, _bottom, _center, _left, _right, _top }